import { Icon, Tooltip } from "@mui/material";
import MDButton from "ui/MDButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React, { useContext, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthContext } from "context";
import { Button, Menu, MenuItem, Divider } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import MDTypography from "ui/MDTypography";

const style = {
  padding: '0',
  minWidth: "75px",
  maxWidth: "75px",
  margin: "0 5px",
  '&.MuiButton-root .material-icons-round': {
    fontSize: '15px!important'
  }
};

// Add Button
export const AddButton = ({ link, loading }) => {
  return (
    <MDButton disabled={loading} component={Link} to={link} color="light">
      <Icon sx={{ fontWeight: "bold" }}>add</Icon>
      &nbsp;Add
    </MDButton>
  );
};


export const MarkButton = ({ link, loading }) => {
  return (
    <MDButton disabled={loading} component={Link} to={link} color="light">
      <Icon sx={{ fontWeight: "bold" }}>mark_as_unread</Icon>
      &nbsp;Mark Attendance
    </MDButton>
  );
};

// Save Button
export const SaveButton = ({ loading, onClick }) => {
  return (
    <MDButton onClick={onClick} disabled={loading} color="light">
      <Icon sx={{ fontWeight: "bold" }}>save</Icon>
      &nbsp;Save
    </MDButton>
  );
};

// Edit Button
export const EditButton = ({ link, permissions = null, loading }) => {
  return (
    <PermissionButton permissions={permissions}>
      <MDButton disabled={loading} color="light" component={Link} to={link} >
        <Icon sx={{ fontWeight: "bold" }}>edit</Icon>
        &nbsp;Edit
      </MDButton>
    </PermissionButton>
  );
};

// Update Button
export const UpdateButton = ({ loading, onClick }) => {
  return (
    <MDButton onClick={onClick} disabled={loading} color="light">
      <Icon sx={{ fontWeight: "bold" }}>update</Icon>
      &nbsp;Update
    </MDButton>
  );
};


export const DetailButton = ({ link, permissions = null, loading }) => {
  return (
    <PermissionButton permissions={permissions}>
      <MDButton color="light" component={Link} to={link} disabled={loading}>
      </MDButton>
    </PermissionButton>
  );
};


export const DeleteButton = ({ clickHandler, permissions = null, loading }) => {
  return (
    <PermissionButton permissions={permissions}>
      <MDButton disabled={loading} color="light" onClick={clickHandler}>
        <Icon sx={{ fontWeight: "bold" }}>delete_outlined</Icon>
        &nbsp;Delete
      </MDButton>
    </PermissionButton>
  );
};

export const ReviewButton = ({ link }) => {
  return (
    <MDButton sx={style} size="small" color="primary" component={Link} to={link}>
      <Icon>feedback</Icon>
    </MDButton>
  );
};









export const IconButton = ({ tooltipTitle, color, icon, onClick }) => {
  return (
    <Tooltip title={tooltipTitle} arrow placement="top">
      <MDButton size="small" sx={style} color={color} onClick={onClick}>
        <Icon>{icon}</Icon>
      </MDButton>
    </Tooltip>
  );
};

export const PermissionButton = ({ permissions, children }) => {
  const { user } = useContext(AuthContext);
  const userPermissions = user?.permissions || []; // Default to an empty array if user is not defined

  const hasPermission =
    !permissions ||
    permissions?.length === 0 ||
    permissions?.some((permission) => userPermissions.includes(permission));

  return hasPermission ? children : null;
};

export const TextLink = ({ link, text }) => (
  <Link to={link}>
    <MDTypography
      variant="caption"
      fontWeight="medium"
      sx={{
        transition: 'all 0.3s ease',
        color: '#1F80FF', // Material UI blue shade
        textDecoration: 'underline',
        '&:hover': {
          color: '#3770BA', // Material UI blue shade
          textDecoration: 'underline',
          transform: 'scale(1.1)', // Slight zoom on hover
        },
        '&:focus': {
          outline: '2px solid #3770BA', // Adding a focus outline for accessibility
        },
      }}
    >
      {text}
    </MDTypography>
  </Link>
);

export const ActionMenu = ({ entity, basePath, onDelete, setNotification }) => {
  console.log("setNotification type:", typeof setNotification); // 👈 ADD HERE

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditClick = () => {
    handleClose();

    // Only apply date check for "meeting"
    if (basePath === "meeting" && entity?.date) {
      const meetingDate = new Date(entity.date);
      const today = new Date();

      // Compare only date (ignore time)
      meetingDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      if (meetingDate < today) {
        // show warning notification if meeting is past
        if (setNotification) {
          setNotification({
            type: "warning",
            message: "This meeting cannot be edited because its date has passed.",
          });
        } else {
          alert("This meeting cannot be edited because its date has passed.");
        }
        return;
      }
    }

    // Default behavior — navigate to edit page
    navigate(`/${basePath}/${entity.id}/edit`);
  };


  const menuItems = [
    {
      icon: "visibility",
      text: "View",
      link: `/${basePath}/${entity.id}/detail`,
    },
    // {
    //   icon: "delete",
    //   text: "Delete",
    //   onClick: () => {
    //     handleClose(); // ✅ close menu first
    //     if (onDelete) onDelete(entity.id); // ✅ explicitly call delete
    //   },
    // },

    {
      icon: "edit",
      text: "Edit",
      onClick: handleEditClick, // ✅ use handler for date check
    },
  ];

  return (
    <>
      <Icon
        onClick={handleClick}
        sx={{ paddingTop: "2px", cursor: "pointer", fontSize: "20px!Important" }}
      >
        more_vert
      </Icon>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 25,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 20,
                width: 14,
                height: 14,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {menuItems.map((item, index) => (
          <React.Fragment key={index}>
            {item.link ? (
              <Link
                to={item.link}
                style={{ color: "black", textDecoration: "none" }}
              >
                <MenuItem onClick={handleClose} sx={{ padding: "7px 15px" }}>
                  <Icon sx={{ marginRight: 1, fontSize: "15px!important" }}>
                    {item.icon}
                  </Icon>
                  {item.text}
                </MenuItem>
              </Link>
            ) : (
              <MenuItem onClick={item.onClick} sx={{ padding: "7px 15px" }}>
                <Icon sx={{ marginRight: 1, fontSize: "15px!important" }}>
                  {item.icon}
                </Icon>
                {item.text}
              </MenuItem>
            )}
          </React.Fragment>
        ))}
      </Menu>
    </>
  );
};